import SearchResultsPage from '../src/pages/SearchResultsPage';

export default SearchResultsPage;
